@if (isLoadingData()) {
  <div class="more-information movie-detail-section more-information--skeleton">
    <ush-movie-detail-skeleton width="12rem" height="1.5rem"></ush-movie-detail-skeleton>
    <div class="more-information--skeleton-content">
      <div class="more-information--skeleton-list">
        @for (row of [1, 2, 3, 4, 5]; track row) {
          <div class="more-information--skeleton-row">
            <ush-movie-detail-skeleton width="8rem" height="1rem"></ush-movie-detail-skeleton>
            <ush-movie-detail-skeleton width="100%" height="1rem"></ush-movie-detail-skeleton>
          </div>
        }
      </div>
      @if (showPortrait) {
        <div class="movie-pic movie-pic--skeleton">
          <ush-movie-detail-skeleton width="100%" height="clamp(20rem, 45vw, 28rem)" radius="18px"></ush-movie-detail-skeleton>
        </div>
      }
    </div>
  </div>
} @else {
  <div
    class="more-information movie-detail-section"
    [class.canCollapse]="canCollapse && !hideTitle()"
    [class.collapsed]="collapsed"
    [class.more-information-has-rightOwners]="showRightOwners && rightOwners"
  >
  <!---->
  <div
    class="header-msg title"
    *ngIf="!hideTitle() && !titleAsLink"
    (click)="toggleCollapse()"
    i18n="@@movie.menu.moreInformation"
    i18n-attr="@@movie.menu.moreInformation"
    data-translate="movie.menu.moreInformation"
  >
    More Information
  </div>
  <a
    class="header-msg title title-link"
    *ngIf="!hideTitle() && titleAsLink"
    [attr.href]="titleAsLink"
    target="_blank"
    i18n="@@movie.menu.moreInformation"
    i18n-attr="@@movie.menu.moreInformation"
    data-translate="movie.menu.moreInformation"
    >More Information</a
  >
  <!---->
  <div class="more-info more-info-content">
    <ul class="info-list">
      <li class="rating-list" *ngIf="movie().certification">
        <div class="subtitle">
          <span i18n="@@movie.field.rating" i18n-attr="@@movie.field.rating" data-translate="movie.field.rating"
            >Rating</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text" [attr.data-translate]="'movie.field.rating.' + movie().certification">
          {{movieRatingTranslations['movie.field.rating.{{ movie().certification }}'] || movie().certification}}
        </div>
      </li>
      <li class="countries-list" *ngIf="infoParams?.countries !== false && countries && countries.length !== 0">
        <div class="subtitle">
          <span i18n="@@movie.field.country" i18n-attr="@@movie.field.country" data-translate="movie.field.country"
            >Country</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text">
          <span *ngFor="let country of countryList" class="crew" [attr.data-translate]="country.trMsg">
            @if (enabledRedirections.includes('countries')) {
              <a [routerLink]="REDIRECTIONS_BASE" [queryParams]="{ country: country.slug }">{{ country.tr }}</a>
            } @else {
              <span>{{ country.tr }}</span>
            }
            <span class="comma">, </span></span
          >
        </div>
      </li>
      <li
        class="languages-list"
        *ngIf="infoParams?.languages !== false && movie().languages && movie().languages.length !== 0"
      >
        <div class="subtitle">
          <span i18n="@@movie.field.language" i18n-attr="@@movie.field.language" data-translate="movie.field.language"
            >Language</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text languages">
          <span *ngFor="let language of languagesList" class="crew" [attr.data-translate]="language.trMsg">
            @if (enabledRedirections.includes('languages')) {
              <a [routerLink]="REDIRECTIONS_BASE" [queryParams]="{ languages: language.slug }">{{ language.tr }}</a>
            } @else {
              <span>{{ language.tr }}</span>
            }
            <span class="comma">, </span>
          </span>
        </div>
      </li>
      <li class="release-list" *ngIf="showReleaseDate" data-type="release">
        <div class="subtitle">
          <span i18n="@@movie.field.release" data-translate="movie.field.release">Release</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text" [attr.data-translate]="locReleaseDate ? '' : infoParams?.releaseDateEmptyMessage">
          {{ releaseDate || infoParams?.releaseDateEmptyMessage }}
        </div>
      </li>
      <li class="release-list" *ngIf="showLocReleaseDate" data-type="loc-release">
        <div class="subtitle">
          <span i18n="@@movie.field.release" data-translate="movie.field.release">Release</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text" [attr.data-translate]="locReleaseDate ? '' : infoParams?.releaseDateEmptyMessage">
          {{ locReleaseDate || infoParams?.releaseDateEmptyMessage }}
        </div>
      </li>
      <li class="release-list" *ngIf="showStreamingDate" data-type="streaming-release">
        <div class="subtitle">
          <span i18n="@@movie.field.streaming.release" [attr.data-translate]="'movie.field.streaming.release'"
            >Streaming Release</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text">{{ streamingReleaseDate }}</div>
      </li>
      <li class="release-list" *ngIf="showLocStreamingDate" data-type="loc-streaming-release">
        <div class="subtitle">
          <span i18n="@@movie.field.streaming.release" [attr.data-translate]="'movie.field.streaming.release'"
            >Streaming Release</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text">{{ locStreamingReleaseDate }}</div>
      </li>

      <!-- THE CHOSEN - ACONTRACORRIENTE HARDCODED -->
      <ng-container
        *ngIf="movie().friendlyUrl === 'the-chosen-1' && channel?.domain === 'www.acontracorrientefilms.com'"
      >
        <li>
          <div class="subtitle">Plataformas:</div>
          <div class="text">acontra+, Movistar Plus</div>
        </li>
        <li>
          <div class="subtitle">DVD y Blu Ray:</div>
          <div class="text">primavera 2024</div>
        </li>
      </ng-container>

      <!--/ THE CHOSEN - ACONTRACORRIENTE HARDCODED -->

      <li class="duration-list" *ngIf="infoParams?.duration !== false && movie().locRuntime">
        <div class="subtitle">
          <span i18n="@@movie.field.duration" i18n-attr="@@movie.field.duration" data-translate="movie.field.duration"
            >Duration</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text">{{ movie().locRuntime }} min</div>
      </li>
      <li class="genres-list" *ngIf="infoParams?.genres !== false && movie().genres && movie()?.genres.length > 0">
        <div class="subtitle">
          <span i18n="@@movie.field.genres" i18n-attr="@@movie.field.genres" data-translate="movie.field.genres"
            >Genres</span
          ><span class="semicolon">:</span>
        </div>
        <div class="text">
          <span
            *ngFor="let genre of genres; let i = index"
            class="crew"
            [attr.data-translate]="movie()?.genres[i]?.trMsg"
          >
            @if (enabledRedirections.includes('genres')) {
              <a
                [routerLink]="REDIRECTIONS_BASE"
                [queryParams]="{ genres: genre.slug }"
                [attr.data-translate]="genre?.trMsg"
              >
                {{ genre.name }}</a
              >
            } @else {
              {{ genre.name }}
            }
            <span class="comma">, </span></span
          >
        </div>
      </li>
      <!-- sales agents -->
      <ng-template [ngTemplateOutlet]="salesAgents"></ng-template>
      <!-- sales agents -->
      <ng-container
        *ngTemplateOutlet="thirdPartyData; context: { $implicit: 'third-party-info-wrapper default' }"
      ></ng-container>
    </ul>
  </div>

  <!-- Right Owners -->
  <div *ngIf="showRightOwners && rightOwners" class="rightOwners rightOwners-more-info">
    <div class="subtitle" i18n-attr="@@movie.field.rightOwner" data-translate="movie.field.rightOwner">
      <span i18n="@@movie.field.rightOwner">Right owner</span><span class="semicolon">:</span>
    </div>
    <div class="contractual-partners">
      <img
        *ngFor="let ro of rightOwners"
        [ngSrc]="ro.logoUrl"
        [alt]="ro.name"
        width="200"
        height="50"
        style="height: auto"
      />
    </div>
  </div>

  <ng-container *ngIf="showPortrait && movie().portraitPhotoUrl">
    <div class="movie-pic">
      <img
        [ngSrc]="movie().portraitPhotoUrl || portraitPlaceholder"
        [alt]="movie().trTitle + ' poster image'"
        width="300"
        height="400"
        style="height: auto"
        [modal]="{ src: movie().portraitPhotoUrl, type: 'portrait', movie: movie(), imgType: 'poster-img' }"
        addSkeleton
      />
      <ng-container
        *ngTemplateOutlet="thirdPartyData; context: { $implicit: 'third-party-info-wrapper secondary hide' }"
      ></ng-container>
    </div>
  </ng-container>
  </div>
}

<!-- THIRD PARTY INFO -->
<ng-template #thirdPartyData let-class>
  <div [ngClass]="class">
    <ul class="third-party-info">
      <li class="imdb" *ngIf="!disableImdb && movie().imdb">
        <a [href]="'https://www.imdb.com/title/' + movie().imdb" target="_blank">
          <img
            [ngSrc]="'https://cdnstatic.usheru.com/img/usheru/imdb-transparent.png'"
            width="80"
            height="40"
            style="height: auto"
            alt="IMDB Logo"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> IMDb</span>
        </a>
      </li>

      <li class="tmdb" *ngIf="!disableTmdb && movie().tmdb">
        <a
          [href]="'https://www.themoviedb.org/' + (movie().contentType === 3 ? 'tv' : 'movie') + '/' + movie().tmdb"
          target="_blank"
        >
          <img
            ngSrc="https://cdnstatic.usheru.com/img/usheru/tmdb-{{ tmdbLogoColor }}.png"
            width="47"
            height="42"
            style="height: auto"
            alt="TMDB Logo"
            loading="eager"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> TMDB</span>
        </a>
      </li>

      <li class="rottentomato" *ngIf="movie().rottentomato && movie().rottentomato !== ''">
        <a [href]="'https://www.rottentomatoes.com/m/' + movie().rottentomato" target="_blank">
          <img
            ngSrc="https://cdnstatic.usheru.com/img/usheru/rottentomato.png"
            width="152"
            height="44"
            style="height: auto"
            alt="Rotten Tomato Logo"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> Rotten Tomato</span>
        </a>
      </li>

      <li class="letterboxd" *ngIf="movie().letterboxd && movie().letterboxd !== ''">
        <a [href]="'https://letterboxd.com/film/' + movie().letterboxd" target="_blank">
          <img
            ngSrc="https://cdnstatic.usheru.com/img/usheru/letterboxd.png"
            width="152"
            height="44"
            alt="Letterboxd Logo"
          />
          <span i18n="@@movie.info.credits.readMoreOn">Read more on</span><span> Letterboxd</span>
        </a>
      </li>

      <li *ngIf="showTPAffinity" class="film-affinity">
        <a [href]="'https://www.filmaffinity.com/es/film457848.html'" target="_blank">
          <img
            [ngSrc]="'https://cdnstatic.usheru.com/img/usheru/filmaffinity.png'"
            width="47"
            height="42"
            alt="FilmAffinity Logo"
          />
        </a>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #salesAgents>
  <li *ngIf="salesAgentsEnabled && movie().salesAgents?.length > 0" class="movie-sales-agents">
    <div class="subtitle">
      <span
        i18n="@@movie.field.salesAgents"
        i18n-attr="@@movie.field.salesAgents"
        data-translate="movie.field.salesAgents"
        >Sales Agent</span
      ><span class="semicolon">:</span>
    </div>
    <div class="sales-agent-images">
      <ng-container *ngFor="let company of movie().salesAgents; index as i">
        <img
          (error)="onSalesAgentLogoError(i)"
          *ngIf="company.logoUrl && !imgWithError(i)"
          [ngSrc]="company.logoUrl"
          [loaderParams]="{ keepHeight: 60 }"
          height="60"
          width="150"
          style="width: auto"
          [alt]="company.name + ' logo'"
        />
        <div *ngIf="!company.logoUrl || imgWithError(i)" class="no-logo-sales-agent">
          {{ company.name }}
        </div>
      </ng-container>
    </div>
  </li>
</ng-template>
